/**
 * DevBar — Barra flotante que aparece SOLO en localhost.
 * Permite cambiar entre contexto Shell / Tenant sin tocar código.
 * En producción (sass.local / *.sass.local) nunca se renderiza.
 */

const isDevHost = ["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname);

export default function DevBar() {
    if (!isDevHost) return null;

    const devMode = sessionStorage.getItem("dev_mode") || "selector";
    const devSub = sessionStorage.getItem("dev_subdomain") || "demo";

    const modeLabel = devMode === "shell" ? "🌐 SaaS Shell"
        : devMode === "tenant" ? `🍽️ Tenant: ${devSub}`
            : "🛠 Dev";

    const goToSelector = () => {
        sessionStorage.removeItem("dev_mode");
        sessionStorage.removeItem("dev_subdomain");
        window.location.href = "/";
    };

    const toggleMode = () => {
        if (devMode === "shell") {
            sessionStorage.setItem("dev_mode", "tenant");
            sessionStorage.setItem("dev_subdomain", devSub);
        } else {
            sessionStorage.setItem("dev_mode", "shell");
        }
        window.location.reload();
    };

    return (
        <div style={s.bar}>
            <span style={s.badge}>DEV</span>
            <span style={s.mode}>{modeLabel}</span>
            <button id="devbar-toggle" onClick={toggleMode} style={s.btn} title="Cambiar contexto">
                ⇄
            </button>
            <button id="devbar-selector" onClick={goToSelector} style={s.btn} title="Ir al selector">
                ☰
            </button>
        </div>
    );
}

const s = {
    bar: {
        position: "fixed",
        bottom: "1rem",
        right: "1rem",
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        gap: "0.4rem",
        background: "rgba(15,23,42,0.92)",
        backdropFilter: "blur(8px)",
        border: "1px solid rgba(234,179,8,0.4)",
        borderRadius: "9999px",
        padding: "0.35rem 0.75rem",
        fontFamily: "monospace",
        fontSize: "0.72rem",
        boxShadow: "0 4px 16px rgba(0,0,0,0.5)",
        userSelect: "none",
    },
    badge: {
        background: "#EAB308",
        color: "#000",
        fontSize: "0.62rem",
        fontWeight: "800",
        padding: "0.1rem 0.4rem",
        borderRadius: "9999px",
        letterSpacing: "0.05em",
    },
    mode: {
        color: "#e2e8f0",
        fontSize: "0.72rem",
    },
    btn: {
        background: "rgba(255,255,255,0.08)",
        border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: "50%",
        width: "22px",
        height: "22px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: "#94a3b8",
        fontSize: "0.75rem",
        padding: 0,
        lineHeight: 1,
    },
};
